import React, { useState, useEffect } from 'react';
import { Input as BInput } from '@blockstack/ui';
import styled from 'styled-components';
function numberWithCommas(val: number | string) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
function covertBack(val: string) {
    return val.toString().replace(/ +?/g, '');
}
type Props = {
    value: number;
    min: number;
    max: number;
    step: number;
    maxLength?: number;
    currencyLabel?: string;
    onChange: (value: number) => void;
};

const InputWrapper = styled.div`
    position: relative;

    ::after {
        content: ${(props: { currencyLabel?: string }) => (props.currencyLabel ? `'${props.currencyLabel}'` : '')};
        position: absolute;
        top: 14px;
        font-size: 14px;
        right: 0.5em;
        transition: all 0.05s ease-in-out;
    }
`;

export const Input: React.FC<Props> = ({ value, min, max, step, maxLength, onChange, currencyLabel }: Props) => {
    const [inputValue, setInputValue] = useState('' + value);

    useEffect(() => {
        setInputValue('' + value);
    }, [value]);
    return (
        <InputWrapper currencyLabel={currencyLabel}>
            <BInput
                min={min}
                maxLength={maxLength || 17}
                max={max}
                value={numberWithCommas(inputValue)}
                step={step}
                height="48px"
                width="100%"
                style={{
                    width: '100%',
                    marginBottom: '28px',
                }}
                onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
                    const currentTarget = event.currentTarget;
                    let value = covertBack(currentTarget.value);
                    const min = currentTarget.min;
                    const max = currentTarget.max;
                    if (Number(value) > Number(max)) {
                        value = max;
                    }

                    if (Number(value) < Number(min)) {
                        value = min;
                    }

                    setInputValue(value);
                    onChange(Number(value));
                }}
                onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) => {
                    if (event.currentTarget.value.indexOf('.') !== -1 && event.which === 46) {
                        event.preventDefault();
                    } else if (event.which !== 46 && (event.which < 48 || event.which > 57)) {
                        event.preventDefault();
                    }
                }}
                onChange={(event: React.FormEvent<HTMLInputElement>) => {
                    const currentTarget = event.currentTarget;
                    let value = covertBack(currentTarget.value);
                    setInputValue(value);
                    // onChange(Number(value));
                }}
            />
        </InputWrapper>
    );
};

export default Input;
